import { Component } from '@angular/core'

@Component({
	template: `<map-presentation></map-presentation>`,
})

export class ContactComponent{}


// WEBPACK FOOTER //
// C:/Users/Administrator/submit text project/gwin/src/app/contact/contact.component.ts